<p-breadcrumb [model]="breadcrumb"></p-breadcrumb>
<h1>Data Import Main</h1>

<main class="mainpayroll">
  <div class="instruction-text">Manage Data Imports for Vendor Invoices, Expense Reports</div>

  <section class="home-grid">
    <ul class="p-grid">

      <li class="p-col-12 p-md-6 p-lg-3 ol-module">
        <button type="text" [routerLink]="[RouteLink.SolMgrVendorInvoiceImport]" pTooltip="Vendor Invoice Imports" tooltipPosition="top">
          <i class="fa fa-id-card-o"></i>
          <h3 class="grid-head">Vendor Invoice Import</h3>
        </button>
      </li>
      <li class="p-col-12 p-md-6 p-lg-3 ol-module">
        <button type="text" [routerLink]="[RouteLink.SolMgrVendorExpenseImport]" pTooltip="Expense Report Imports" tooltipPosition="top">
          <i class="fa fa-id-card-o"></i>
          <h3 class="grid-head">Expense Report Import</h3>
        </button>
      </li>


      <!--
      <li class="p-col-12 p-md-6 p-lg-3">
        <i class="fa fa-calculator"></i>
        <h3 class="grid-head">Tax Info</h3>
        <ul style="padding-left: 0;">
          <li>
            <a [routerLink]="[TaxFiling]" routerLinkActive="active">Tax Filings</a>
          </li>
        </ul>
      </li> -->
    </ul>
  </section>

  <!-- <div class="ui-g main-stats">
    <div class="p-col-12 p-md-6 p-lg-3">
      <h4>To Do</h4>
      <div class="stat-area stat-gear">
        <div class="stat-value">xxxxx</div>
        <div class="stat-description">Lorem ipsum dolor est divisa
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6 p-lg-3">
      <h4>Messages</h4>
      <div class="stat-area stat-link">
        <div class="stat-value">xxxxx</div>
        <div class="stat-description">Lorem ipsum dolor est divisa
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6 p-lg-3">
      <h4>Last Payroll</h4>
      <div class="stat-area stat-people">
        <div class="stat-value">xxxxx</div>
        <div class="stat-description">Lorem ipsum dolor est divisa
        </div>
      </div>
    </div>
    <div class="p-col-12 p-md-6 p-lg-3">
      <h4>Trends - Payroll by Month</h4>
      <div class="stat-area stat-gear">
        <div class="stat-value">xxxxx</div>
        <div class="stat-description">Lorem ipsum dolor est divisa
        </div>
      </div>
    </div>
  </div> -->
</main>

